module.exports = "<div seedelement>\n  <div class=\"lui-desktopnavigation__logo\">\n    <slot name=\"logo\">\n      <lui-logo></lui-logo>\n    </slot>\n  </div>\n  <div class=\"lui-desktopnavigation__main\">\n    <slot></slot>\n  </div>\n  <slot name=\"controls\"></slot>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-desktopnavigation/theme/lui-desktopnavigation.html
// module id = 207
// module chunks = 0 1 34